module.exports = __webpack_public_path__ + "static/img/19.9e0bc96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/19.png
// module id = JVOQ
// module chunks = 0